
let btnResetBlockVisable = document.querySelector('.reset-password-block .row-title .r-action'),
    resetPasswordButton =  document.querySelector('.reset-password-block .reset-password-btn'),
    forgotPasswordLink =  document.querySelector('.login-password__recover-link');

resetPasswordButton.addEventListener('click', function(e) {
     forgotPasswordLink.click();
});

btnResetBlockVisable.addEventListener('click', function(e) {
   let resetPasswordBoxContent = document.querySelector('.reset-password-block .row-content');
   if (resetPasswordBoxContent.classList.contains('active')) {
      resetPasswordBoxContent.classList.remove('active');
      btnResetBlockVisable.textContent = 'View';
   } else {
      resetPasswordBoxContent.classList.add('active');
      btnResetBlockVisable.textContent = 'Hide';
   }
});